import angular from 'angular';

export class CompanyComponent {
  menu = [
    {
      title1: '会社情報',
      title2: '',
      state: 'company-top',
      image: 'assets/images/IMG_0812-4.jpg',
      imageS: 'assets/images/IMG_0812-960.jpg'
    },
    {
      title1: '新型コロナウイルスのお知らせ',
      title2: '',
      state: 'covid-notice',
      image: 'assets/images/office.jpg',
      imageS: 'assets/images/office-960.jpg'
    },
    {
      title1: 'トップ',
      title2: 'メッセージ',
      state: 'statement',
      image: 'assets/images/IMG_1171_2.jpg',
      imageS: 'assets/images/IMG_1171-960.jpg'
    },
    {
      title1: '会社概要',
      title2: '',
      state: 'about',
      image: 'assets/images/IMG_1003-1.jpg',
      imageS: 'assets/images/IMG_1003-960.jpg'
    },
    {
      title1: 'アクセス',
      title2: '',
      state: 'access',
      image: 'assets/images/IMG_1031.jpg',
      imageS: 'assets/images/IMG_1031-960.jpg'
    },
    {
      title1: 'グループ',
      title2: '会社',
      state: 'group',
      image: 'assets/images/world-trip2.jpg',
      imageS: 'assets/images/world-trip2-960.jpg'
    }
  ]

  constructor() {
    this.currentTitle1 = '会社情報';
    this.currentTitle2 = '';
    this.currentImage = 'assets/images/IMG_0812-4.jpg';
    this.currentImageS = 'assets/images/IMG_0812-960.jpg';
  }
  getCurrentPage(currentTitle1, currentTitle2, currentImage, currentImageS) {
    this.currentTitle1 = currentTitle1;
    this.currentTitle2 = currentTitle2;
    this.currentImage = currentImage;
    this.currentImageS = currentImageS;
  }
}

export default angular.module('directives.company', [])
  .component('company', {
    template: require('./company.template.html'),
    controller: CompanyComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/company/company.component.js